import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';

import './select_box.scss';

const CLASS_NAME = 'flex-table-select-box';

const { LINK_PRIMARY } = Buttons.constants.BUTTON_THEMES;

const SelectBox = props => {
  const { onSelectAllMatching, onClearAll, selectedCount, objectName, dataCount } = props;
  const allSelected = _.isEqual(dataCount, selectedCount);
  return (
    <div className={CLASS_NAME}>
      <div className={`${CLASS_NAME}__text`}>
        All <span className={`${CLASS_NAME}__text--strong`}>{selectedCount}</span>
        {`${allSelected ? ' matching' : ''}`} {objectName}
        {`${!allSelected ? ' on this page ' : ' '}`}
        selected.
      </div>
      {allSelected ? (
        <Buttons.Button onClick={onClearAll} theme={LINK_PRIMARY}>
          Clear all
        </Buttons.Button>
      ) : (
        <Buttons.Button onClick={onSelectAllMatching} theme={LINK_PRIMARY}>
          Select all {dataCount} matching {objectName}
        </Buttons.Button>
      )}
    </div>
  );
};

SelectBox.propTypes = {
  dataCount: PropTypes.number.isRequired,
  objectName: PropTypes.string.isRequired,
  onClearAll: PropTypes.func.isRequired,
  onSelectAllMatching: PropTypes.func.isRequired,
  selectedCount: PropTypes.number.isRequired,
};

export default SelectBox;
